import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ACCOUNT_DELETE, SUB_ACCOUNT_DELETE } from "./constant";
import {
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
  MotifModalFooter,
  MotifButton,
} from "@/libs/@ey-xd/motif-react";
import {
  useLazyDeleteAccountQuery,
  useLazyDeleteSubAccountQuery,
} from "@/services/configuration/configuration";
import {
  CANCEL_BUTTON_VARIANT,
  CONFIRM_BUTTON_VARIANT,
} from "@/components/Images/CommonImages";
import { CommonModalHeader } from "@/components/Modal/CommonModalHeader/CommonModalHeader";
import { useTrans } from "@/components/Functions/dateFunc";

interface ApiResponse {
  data?: any;
  error?: any;
}

const DeleteAccountSubAccount = ({
  show,
  setShow,
  id,
  isAccount,
  setDeleteErrorMessage,
  refetch,
  deleteEntityName,
  setStatusMsg,
  setShowDeleteSuccessErrorMessage,
  showDeleteSuccessErrorMessage,
  setDeleteAccountId,
}: {
  show: boolean;
  setShow: (show: boolean) => void;
  id: any;
  isAccount: boolean;
  setDeleteErrorMessage: any;
  refetch: any;
  deleteEntityName: string;
  setStatusMsg: (msg: string) => void;
  setShowDeleteSuccessErrorMessage?: any;
  showDeleteSuccessErrorMessage?: any;
  setDeleteAccountId?: any;
}) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [deleteAccountQuery] = useLazyDeleteAccountQuery();
  const [deleteSubAccountQuery] = useLazyDeleteSubAccountQuery();

  const handleDelete = async () => {
    setStatusMsg("");
    const deleteQuery = isAccount ? deleteAccountQuery : deleteSubAccountQuery;
    setDeleteErrorMessage({ message: "", type: "" });
    setIsLoading(true);
    deleteQuery(id).then((response: ApiResponse) => {
      if (response.data) {
        refetch()?.then(() => {
          const successMessage = isAccount
            ? ACCOUNT_DELETE
            : SUB_ACCOUNT_DELETE;
          setDeleteAccountId && setDeleteAccountId("");

          if (showDeleteSuccessErrorMessage?.index >= 0) {
            setShowDeleteSuccessErrorMessage &&
              setShowDeleteSuccessErrorMessage({
                ...showDeleteSuccessErrorMessage,
                message: successMessage,
                type: "success",
                variant: isAccount ? "account" : "subAccount",
                show: true,
              });
          } else {
            setDeleteErrorMessage({ message: successMessage, type: "success" });
          }
          setIsLoading(false);
          setShow(false);
        })?.catch(() => {
          setIsLoading(false);
          setShow(false);
          setDeleteErrorMessage({ message: t("global.globalNotifications.wentWrong"), type: "errorsssss" });

        });
      } else {
        let target = document.getElementById(id);
        if (target) {
          target.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
        const errorMessage = response?.error?.data?.message;
        setDeleteErrorMessage({ message: errorMessage, type: "error" });
        setIsLoading(false);
        setShow(false);
      }
    });
  };

  const handleCancel = () => {
    setShow(false);
    setDeleteErrorMessage({ message: "", type: "" });
  };

  return (
    <>
      <MotifModal
        onClose={handleCancel}
        show={show}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
      >
        <div className="confirmationModalWrapper creditor_disabling_model">
          <MotifModalHeader headerIcon={CommonModalHeader()}></MotifModalHeader>

          <MotifModalBody style={{ paddingTop: "0px" }}>
            {useTrans(
              t,
              t(
                isAccount
                  ? "pages.configuration.accounts.deleteAccountMessage"
                  : "pages.configuration.accounts.deleteSubAccountMessage",
                { accountName: deleteEntityName }
              ),
              "accountName"
            )}
          </MotifModalBody>

          <MotifModalFooter>
            <MotifButton
              onClick={handleCancel}
              type="button"
              variant={CANCEL_BUTTON_VARIANT}
            >
              {t("pages.configuration.stages.cancel")}
            </MotifButton>
            <MotifButton
              onClick={handleDelete}
              type={isLoading ? "loader" : "submit"}
              variant={CONFIRM_BUTTON_VARIANT}
            >
              {t("pages.configuration.stages.confirm")}
            </MotifButton>
          </MotifModalFooter>
        </div>
      </MotifModal>
    </>
  );
};
export default DeleteAccountSubAccount;
